import { createElementVNode, defineComponent, inject, reactive, watch, onMounted, openBlock, createElementBlock, normalizeStyle, Fragment, renderList, createBlock, resolveDynamicComponent, mergeProps, withCtx, toDisplayString, createVNode, createTextVNode, createCommentVNode } from 'vue';
import { getPublishTimestamp } from '../../../utils/index.mjs';
import request from '../../../utils/request.mjs';
import { API_BASE } from '../../../utils/getConstant.mjs';
import TvbLogoMiniIcon from '../../Icon/LogoMini.vue.mjs';

const _hoisted_1 = { class: "tvb-footer" };
const _hoisted_2 = { class: "tvb-footer_links-about-apps" };
const _hoisted_3 = { class: "tvb-footer_links-about" };
const _hoisted_4 = { class: "tvb-footer_links" };
const _hoisted_5 = /* @__PURE__ */ createElementVNode("h2", { class: "tvb-footer_links-title" }, "\u76F8\u95DC\u9023\u7D50", -1);
const _hoisted_6 = { class: "tvb-footer_links-navs" };
const _hoisted_7 = ["title"];
const _hoisted_8 = { class: "tvb-footer_links" };
const _hoisted_9 = /* @__PURE__ */ createElementVNode("h2", { class: "tvb-footer_links-title" }, "\u95DC\u65BC\u6211\u5011", -1);
const _hoisted_10 = { class: "tvb-footer_links-navs" };
const _hoisted_11 = ["title"];
const _hoisted_12 = { class: "tvb-footer_apps" };
const _hoisted_13 = /* @__PURE__ */ createElementVNode("h2", { class: "footer_apps-title" }, "\u61C9\u7528\u7A0B\u5F0F", -1);
const _hoisted_14 = { class: "tvb-footer_apps-navs" };
const _hoisted_15 = ["src", "alt"];
const _hoisted_16 = { class: "tvb-footer-copyright-follow" };
const _hoisted_17 = { class: "tvb-footer-copyright" };
const _hoisted_18 = { class: "tvb-footer-follows" };
const _hoisted_19 = /* @__PURE__ */ createElementVNode("h2", { class: "tvb-footer_follows-title" }, "\u95DC\u6CE8\u6211\u5011", -1);
const _hoisted_20 = ["src", "alt"];
const _hoisted_21 = {
  key: 0,
  class: "tvb-footer-follow-qr-code"
};
const _hoisted_22 = ["src", "alt"];
const __default__ = defineComponent({
  name: "TvbFooter"
});
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: {
    maxWidth: null,
    fullPath: null
  },
  emits: ["click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const env = inject("env");
    const footer = reactive({
      menus: {},
      maxWidth: props.maxWidth || "1712px"
    });
    watch(
      () => props.maxWidth,
      () => {
        footer.maxWidth = props.maxWidth;
      }
    );
    const getFooter = () => {
      request.get(`/footer?_t=${getPublishTimestamp()}`, {
        baseURL: API_BASE(env || "prod")
      }).then(({ data }) => {
        footer.menus = data != null ? data : [];
      });
    };
    const utmParams = (path, text) => {
      const url = new URL(path);
      url.searchParams.set("utm_campaign", text);
      url.searchParams.set("utm_source", "tvbcomhomepage");
      url.searchParams.set("utm_medium", "footer");
      return url.href;
    };
    onMounted(() => getFooter());
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("footer", _hoisted_1, [
        createElementVNode("div", {
          class: "tvb-footer_container",
          style: normalizeStyle({ maxWidth: footer.maxWidth })
        }, [
          createElementVNode("div", _hoisted_2, [
            createElementVNode("div", _hoisted_3, [
              createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                createElementVNode("nav", _hoisted_6, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(footer.menus.link || [], (menu, index) => {
                    return openBlock(), createBlock(resolveDynamicComponent((menu == null ? void 0 : menu.jump_url) ? "a" : "span"), mergeProps({ key: index }, {
                      rel: (menu == null ? void 0 : menu.link_rel) === 1 ? "follow" : (menu == null ? void 0 : menu.link_rel) === 2 ? "nofollow" : "",
                      target: (menu == null ? void 0 : menu.link_target) === 1 ? "_self" : (menu == null ? void 0 : menu.link_target) === 2 ? "_blank" : ""
                    }, {
                      class: "tvb-footer_link",
                      href: (menu == null ? void 0 : menu.jump_url) ? utmParams(menu == null ? void 0 : menu.jump_url, menu.utm_campaign || (menu == null ? void 0 : menu.title)) : null,
                      onClick: (event) => emits("click", { ...menu, event, event_label: "footer-menu" })
                    }), {
                      default: withCtx(() => [
                        createElementVNode("h3", {
                          class: "tvb-footer_link-text",
                          title: menu == null ? void 0 : menu.title
                        }, toDisplayString(menu == null ? void 0 : menu.title), 9, _hoisted_7)
                      ]),
                      _: 2
                    }, 1040, ["href", "onClick"]);
                  }), 128))
                ])
              ]),
              createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                createElementVNode("nav", _hoisted_10, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(footer.menus.about || [], (menu, index) => {
                    return openBlock(), createBlock(resolveDynamicComponent((menu == null ? void 0 : menu.jump_url) ? "a" : "span"), mergeProps({ key: index }, {
                      rel: (menu == null ? void 0 : menu.link_rel) === 1 ? "follow" : (menu == null ? void 0 : menu.link_rel) === 2 ? "nofollow" : "",
                      target: (menu == null ? void 0 : menu.link_target) === 1 ? "_self" : (menu == null ? void 0 : menu.link_target) === 2 ? "_blank" : ""
                    }, {
                      class: "tvb-footer_link",
                      href: (menu == null ? void 0 : menu.jump_url) ? utmParams(menu == null ? void 0 : menu.jump_url, menu.utm_campaign || (menu == null ? void 0 : menu.title)) : null,
                      onClick: (event) => emits("click", { ...menu, event, event_label: "footer-menu" })
                    }), {
                      default: withCtx(() => [
                        createElementVNode("h3", {
                          class: "tvb-footer_link-text",
                          title: menu == null ? void 0 : menu.title
                        }, toDisplayString(menu == null ? void 0 : menu.title), 9, _hoisted_11)
                      ]),
                      _: 2
                    }, 1040, ["href", "onClick"]);
                  }), 128))
                ])
              ])
            ]),
            createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              createElementVNode("nav", _hoisted_14, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(footer.menus.app || [], (menu, index) => {
                  return openBlock(), createBlock(resolveDynamicComponent((menu == null ? void 0 : menu.jump_url) ? "a" : "span"), mergeProps({ key: index }, {
                    rel: (menu == null ? void 0 : menu.link_rel) === 1 ? "follow" : (menu == null ? void 0 : menu.link_rel) === 2 ? "nofollow" : "",
                    target: (menu == null ? void 0 : menu.link_target) === 1 ? "_self" : (menu == null ? void 0 : menu.link_target) === 2 ? "_blank" : ""
                  }, {
                    class: "tvb-footer_app",
                    href: (menu == null ? void 0 : menu.jump_url) ? utmParams(menu == null ? void 0 : menu.jump_url, menu.utm_campaign || (menu == null ? void 0 : menu.title)) : null,
                    title: menu == null ? void 0 : menu.title,
                    onClick: (event) => emits("click", { ...menu, event, event_label: "footer-menu" })
                  }), {
                    default: withCtx(() => [
                      createElementVNode("img", {
                        class: "tvb-footer_app_logo",
                        src: menu.app_logo,
                        alt: menu.alt_text
                      }, null, 8, _hoisted_15)
                    ]),
                    _: 2
                  }, 1040, ["href", "title", "onClick"]);
                }), 128))
              ])
            ])
          ]),
          createElementVNode("div", _hoisted_16, [
            createElementVNode("p", _hoisted_17, [
              createVNode(TvbLogoMiniIcon),
              createTextVNode(" Copyright \xA9" + toDisplayString(new Date().getFullYear()) + " Television Broadcasts Limited ", 1)
            ]),
            createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              (openBlock(true), createElementBlock(Fragment, null, renderList(footer.menus.follow || [], (menu, index) => {
                return openBlock(), createBlock(resolveDynamicComponent((menu == null ? void 0 : menu.jump_url) ? "a" : "span"), mergeProps({ key: index }, {
                  rel: (menu == null ? void 0 : menu.link_rel) === 1 ? "follow" : (menu == null ? void 0 : menu.link_rel) === 2 ? "nofollow" : "",
                  target: (menu == null ? void 0 : menu.link_target) === 1 ? "_self" : (menu == null ? void 0 : menu.link_target) === 2 ? "_blank" : ""
                }, {
                  class: "tvb-footer-follow",
                  href: (menu == null ? void 0 : menu.jump_url) ? menu == null ? void 0 : menu.jump_url : null,
                  title: menu == null ? void 0 : menu.title,
                  onClick: (event) => emits("click", { ...menu, event, event_label: "footer-menu" })
                }), {
                  default: withCtx(() => [
                    createElementVNode("img", {
                      class: "tvb-footer-follow-logo",
                      src: menu.app_logo,
                      alt: menu.alt_text
                    }, null, 8, _hoisted_20),
                    menu.qr_code ? (openBlock(), createElementBlock("div", _hoisted_21, [
                      createElementVNode("img", {
                        class: "tvb-footer-follow-qr-code-img",
                        src: menu.qr_code,
                        alt: menu.alt_text
                      }, null, 8, _hoisted_22)
                    ])) : createCommentVNode("v-if", true)
                  ]),
                  _: 2
                }, 1040, ["href", "title", "onClick"]);
              }), 128))
            ])
          ])
        ], 4)
      ]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=Footer.vue2.mjs.map
